import React, { useMemo } from "react";

// import styles from "./styles/Menu.module.scss";
import { RiLockPasswordFill } from "react-icons/ri";
import { SiGoogledocs } from "react-icons/si";
import { MdMarkEmailRead } from "react-icons/md";

import { Description, SubTitle } from "../../Components";
import { ROUTES } from "./contants";

export default function Menu({ route, setRoute }) {
  const OPTIONS = useMemo(() => {
    return [
      // {
      //     label: 'Edit Profile',
      //     route: ROUTES.EDIT_PROFILE,
      //     icon: <EditIcon />
      // },
      {
        label: "Change Password",
        route: ROUTES.CHANGE_PASSWORD,
        icon: <RiLockPasswordFill size={20} />,
      },
      {
        label: "Coin Conversion",
        route: ROUTES.COIN_CONVERSION,
        icon: <SiGoogledocs size={20} />,
      },
      {
        label: "Terms And Conditions",
        route: ROUTES.TERMS_CONDITIONS,
        icon: <SiGoogledocs size={20} />,
      },
      {
        label: "Privacy Policy",
        route: ROUTES.PRIVACY_POLICY,
        icon: <SiGoogledocs size={20} />,
      },
      {
        label: "Black Jack Rules",
        route: ROUTES.BLACK_JACK_RULES,
        icon: <SiGoogledocs size={20} />,
      },
      {
        label: "Baccarat Rules",
        route: ROUTES.BACCARAT_RULES,
        icon: <SiGoogledocs size={20} />,
      },
      {
        label: "Slot Machine Rules",
        route: ROUTES.SLOT_MACHINE_RULES,
        icon: <SiGoogledocs size={20} />,
      },
      {
        label: "Prize Pool Rules",
        route: ROUTES.PRIZE_POOL_RULES,
        icon: <SiGoogledocs size={20} />,
      },
      {
        label: "Digit Dream Rules",
        route: ROUTES.DIGIT_DREAM_RULES,
        icon: <SiGoogledocs size={20} />,
      },
      // {
      //     label: 'Contact Us',
      //     route: ROUTES.CONTACT_US,
      //     icon: <MdMarkEmailRead size={20} />
      // },
    ];
  }, []);

  const handleMenuItemClick = (route) => {
    console.log(route);
    setRoute(route);
  };

  return (
    <div className={"Menu"}>
      <SubTitle text="Setting" classes="text-white" />
      {/* <Description
        text="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        classes="mt-1 mb-4 fs-8 text-white"
      /> */}
      {OPTIONS.map((item, index) => {
        return (
          <div
            className={`${"option"} my-3 ${route === item.route ? "active" : ""
              }`}
            key={item.label}
            onClick={() => handleMenuItemClick(item.route)}
          >
            <span className={"icon"}>{item?.icon}</span>
            <Description text={item.label} classes="fs-7" />
          </div>
        );
      })}
    </div>
  );
}
